import { type ServiceMethod } from '@/application/interfaces/service';
import { type AddedService } from '@/infra/services/checkout/model';

export type Body = {
  override?: boolean;
  services: {
    id: number | string;
    quantity: number;
    skuId?: string | null;
    relatedId?: string;
  }[];
};

export type Params = {
  cartId: string;
};

export type Data = Body & Params;

export type Response = {
  data: AddedService[];
};

const addServicesToCartById: ServiceMethod<Response, Data> =
  (httpClient) => async (data, options) => {
    const { cartId, services, override } = data;

    const { body: response } = await httpClient.post<Response, Body, Params>(
      '/api/v3/carts/{cartId}/services/',
      {
        ...options,
        body: {
          services,
          override,
        },
        params: {
          cartId,
        },
      }
    );

    return response;
  };

export default addServicesToCartById;
